import { useAppSelector } from 'hooks'
import { useEffect } from 'react'
import { getLastNotificationStepSelector } from 'redux/store/slices/wsSlice'
import { FLOW_STEPS } from 'share/types'
import { STEPS_WITH_MANUAL_RESOLUTION } from 'utils/constants'
import { MANUAL_WS_STEP_CHECK_HANDLERS } from 'utils/step-resolvers/ws-step-resolvers'

const useGlobalWsStepHandler = ({ onStepError }: { onStepError: () => Promise<void> }) => {
  const lastStepData = useAppSelector(getLastNotificationStepSelector)

  useEffect(() => {
    const checkLastStepData = async () => {
      if (!lastStepData) return
      const isStepsNeedsManualCheck = MANUAL_WS_STEP_CHECK_HANDLERS.some(handler => handler(lastStepData.value))

      if (STEPS_WITH_MANUAL_RESOLUTION.includes(lastStepData.value.step_type as FLOW_STEPS)) return
      if (isStepsNeedsManualCheck) return
      const {
        can_retry,
        is_final,
        is_success,
        is_colvir_worktime,
        depends_on_colvir_worktime,
        next_step_depends_on_colvir_worktime
      } = lastStepData.value

      if (
        (is_final && is_success === false && can_retry) ||
        (!is_colvir_worktime && (depends_on_colvir_worktime || next_step_depends_on_colvir_worktime))
      ) {
        await onStepError()
      }
    }

    checkLastStepData()
  }, [lastStepData, onStepError])
}

export { useGlobalWsStepHandler }
